/**
 * 店舗グループ関連のQuery Hooks
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getSellerGroups } from '@/lib/api/seller-group';
import { sellerGroupKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * 店舗グループ一覧を取得するQuery Hook
 * @param accountCode アカウントコード
 */
export function useSellerGroups(accountCode: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: sellerGroupKeys.list(accountCode),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getSellerGroups(accountCode, authHeaders);
    },
    enabled: !authHeaderLoading && isAuthorized && !!accountCode,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
